<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/132dh5s/tc-custom/9781614234081.jpg?1694742613326" alt="This image is the cover for the book Haunted Fort Worth, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Fort Worth, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>In Fort Worth, the past and present exist side by side and spirits walk among the living. Stay the night at Miss Molly's Hotel; the oldest bed-and-breakfast in the city boasts frequent eerie occurrences and unexplained sightings. Nearby, Cattlemen's Fort Worth Steak House features a special like no other, just watch out for flying liquor! From Bonnie and Clyde's old "haunts" to the once notorious Hell's Half Acre, Fort Worth is filled with historic spots rumored to play host to lingering ghosts and specters.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rita Cook, Russell W. Danoridge
      </h2>
      
      <p class="authorDescription body article">Rita Cook is a writer/editor who specializes in a variety of subjects, primarily travel, entertainment and automobiles, with a special emphasis on haunted houses and ghosts, since she grew up in a house full of ghosts. She most recently published a book titled A Brief History of Fort Worth with The History Press and co-wrote a book to be released in the fall called Tourist Town Guides: Fredericksburg, Texas. She also has a book, Haunted Dallas, to be released. With well over one thousand articles to her credit in the past twelve years, Cook is the managing editor of Celeb Life Magazine and editor in chief of Insider Magazine. She began her journalism career in Chicago working at Insider Magazine and the Chicago Sun Times. She currently has a green column, Green Life, "? in the Dallas Morning News and an auto column, "Behind the Wheel, "? in the Washington Times, Communities. She writes for a variety of newspapers and magazines locally and nationally, and in addition to her latest books, she has three other titles under her name. Cook can also be heard on the radio every Sunday morning in Los Angeles on The Insider Magazine Radio Show's featured segment "I'm Standing Here."?"</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29d4e41e